import React from 'react'
import PropTypes from 'prop-types'
import { FormattedTime, FormattedDate, FormattedMessage } from 'react-intl'

const InvitationBlock = ({ invitation }) => (
  <div className="bg-grass-60 p-8 pb-4 mb-8 text-center">
    <h1>
      <FormattedMessage
        id="booking.amountForm.invitation.header"
        defaultMessage="Hi {firstName}"
        values={{ firstName: invitation.firstName }}
      />      
    </h1>
    <p>
      <FormattedMessage
        id="booking.amountForm.invitation.ln1"
        defaultMessage="{inviterFirstName} has invited you to join him for trip down the slopes of CopenHill!"
        values={{ inviterFirstName: <b>{invitation.booking.user.firstName}</b> }}
      /> 
    </p>
    <div>
      <FormattedMessage id="booking.amountForm.invitation.ln2" defaultMessage="He’s reserved a spot for you on:" /> 
      
    </div>
    <div className="font-bold">
      <FormattedDate value={invitation.booking.dateStart} year='numeric' month='long' day='numeric' />
    </div>
    <div className="font-bold">
      <FormattedTime value={invitation.booking.dateStart} />
      &nbsp; -&nbsp;
      <FormattedTime value={invitation.booking.dateEnd} />
    </div>
  </div>
)


InvitationBlock.propTypes = {
  invitation: PropTypes.shape({ invitation: PropTypes.object }).isRequired
}

export default InvitationBlock